(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-approved-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-product-gallery')) {
    customElements.define('sb-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.sb-gallery__track');
        this.slides = [...this.querySelectorAll('.sb-gallery__slide')];
        this.thumbnails = [...this.querySelectorAll('.sb-gallery__thumbnail')];
        this.dialog = this.querySelector('dialog');
        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', event => {
            event.preventDefault();
            this.track.scrollTo({ left: this.slides[index].offsetLeft - this.slides[0].offsetLeft, behavior: 'instant' });
            this.select(index);
          }, options);
        });
        this.track.addEventListener('scroll', () => {
          const trackBox = this.track.getBoundingClientRect();
          let closest = 0;
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const delta = Math.abs(slide.getBoundingClientRect().left - trackBox.left);
            if (delta < distance) { closest = index; distance = delta; }
          });
          this.select(closest);
        }, { ...options, passive: true });
        this.querySelectorAll('.sb-gallery__enlarge').forEach(link => {
          link.addEventListener('click', event => {
            if (!this.dialog.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            const photo = link.querySelector('img').cloneNode();
            photo.removeAttribute('srcset');
            photo.removeAttribute('sizes');
            photo.src = link.href;
            photo.loading = 'eager';
            this.querySelector('.sb-gallery__enlarged').replaceChildren(photo);
            this.dialog.showModal();
          }, options);
        });
        this.querySelector('.sb-gallery__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
      }
      select(index) {
        this.slides.forEach((slide, slideIndex) => {
          if (slideIndex !== index) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          if (thumbnailIndex === index) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
